import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';

export const tenantGuard: CanActivateFn = (route) => {
  const tenantService = inject(TenantService);
  const router = inject(Router);
  const tenantId = route.paramMap.get('tenantId');

  if (!tenantId || !tenantService.canUseTenant(tenantId)) {
    return router.createUrlTree(['/auth/select-company']);
  }

  tenantService.activateFromRoute(tenantId);
  return true;
};
